import _trimInstanceProperty from "@babel/runtime-corejs3/core-js/instance/trim";
export const htmlToTextContent = (html = "") => {
  const tempNode = document.createElement("div");
  tempNode.innerHTML = html;
  const textContent = tempNode.textContent || tempNode.innerText || "";
  return _trimInstanceProperty(textContent).call(textContent);
};

/**
 * The purpose of this mixin is to convert an html string into
 * its text-only representation, free from any tags
 */
export default {
  methods: {
    htmlToTextContent
  }
};